module.exports = __webpack_public_path__ + "img/Notisphere_Icon_Crescent_Mono_Dark.b7943274.svg";